import { MenuItem, Select } from '@mui/material';
import React from 'react';
import { SELECT_VARIANTS, SIZES } from '../../../../constants/constants';
import I18n from '../../../../i18n/I18n';
import { REVOKED_SHARE_ACTION, SHARE_PERMISSION_OPTIONS } from '../../../constants';
import type { ShareAction } from '../../../types';

type ShareActionOption = { value: ShareAction; labelToken: string };
const SHARE_RESTRICTION_TYPE_TEST_ID = 'shareSettingsRestrictionType';

export type ShareActionFormFieldProps = {
    value: ShareAction;
    onChange: (value: ShareAction) => void;
    disabled?: boolean;
    hasChanged?: boolean;
    minWidth?: number;
    options?: ShareActionOption[];
};

export default function ShareActionFormField({
    value,
    onChange,
    disabled,
    hasChanged,
    minWidth = 90,
    options = SHARE_PERMISSION_OPTIONS
}: ShareActionFormFieldProps) {
    return (
        <Select
            disabled={disabled}
            size={SIZES.small}
            variant={SELECT_VARIANTS.standard}
            value={value}
            data-testid={SHARE_RESTRICTION_TYPE_TEST_ID}
            data-share-restriction-type={value}
            onChange={(e) => onChange(e.target.value)}
            sx={{
                fontSize: '12px',
                minWidth,
                fontStyle: hasChanged ? 'italic' : 'normal'
            }}
        >
            {options.map((opt) => (
                <MenuItem
                    key={opt.value}
                    value={opt.value}
                    data-testid={`${SHARE_RESTRICTION_TYPE_TEST_ID}Option-${opt.value}`}
                    sx={{
                        ...(opt.value === REVOKED_SHARE_ACTION && {
                            borderTop: '1px solid',
                            borderColor: 'divider',
                            color: 'error.main'
                        }),
                        '&.Mui-selected': {
                            color: opt.value === REVOKED_SHARE_ACTION ? 'error.main' : 'text.primary',
                            '&:hover': {
                                backgroundColor: 'action.hover',
                                color: opt.value === REVOKED_SHARE_ACTION ? 'error.main' : 'text.primary'
                            }
                        }
                    }}
                >
                    <I18n token={opt.labelToken} />
                </MenuItem>
            ))}
        </Select>
    );
}
